"use client";

import { SectionLabel } from "@/components/ui/section-label";

type PageErrorProps = {
	error: Error & { digest?: string };
	reset: () => void;
};

// Next.js requires error boundaries to be client components.
export default function PageError({ error: _error, reset }: PageErrorProps) {
	return (
		<div className="flex min-h-screen flex-col items-start justify-center px-8">
			<div className="mb-3">
				<SectionLabel>ERROR</SectionLabel>
			</div>
			<h1 className="mb-4 font-bold text-display-md leading-tight tracking-[var(--tracking-display)] normal-case">
				Something went wrong loading this page.
			</h1>
			<p className="mb-6 font-mono text-mono-sm opacity-60">
				The request couldn&apos;t be completed. Try again or come back later.
			</p>
			<button
				type="button"
				onClick={reset}
				className="border-2 border-ink bg-ink px-4 py-2 font-mono text-mono-sm tracking-widest text-paper transition-colors hover:bg-paper hover:text-ink"
			>
				TRY AGAIN
			</button>
		</div>
	);
}
